import { Link } from "react-router-dom";
import { Facebook, Instagram, Twitter, Youtube, Settings } from "lucide-react";
import motorevealLogo from "@/assets/motoreveal-logo.png";
import { NewsletterSignup } from "./NewsletterSignup";
import { showCookieBanner } from "./CookieConsent";
const SOCIAL_LINKS = [
{
  icon: Facebook,
  href: "https://www.facebook.com/motoreveal",
  label: "Facebook"
},
{
  icon: Instagram,
  href: "https://www.instagram.com/moto.reveal",
  label: "Instagram"
},
{
  icon: Twitter,
  href: "https://x.com/motoreveal",
  label: "Twitter"
},
{
  icon: Youtube,
  href: "https://www.youtube.com/@moto.reveal",
  label: "Youtube"
}];

const EXPLORE_LINKS = [
{
  label: "Car Events",
  href: "/events"
},
{
  label: "Experiences",
  href: "/experiences"
},
{
  label: "Map View",
  href: "/map"
},
{
  label: "Favorites",
  href: "/favorites"
}];


const FOR_LISTERS_LINKS = [
{
  label: "For Organizers",
  href: "/for-organizers"
},
{
  label: "For Experience Owners",
  href: "/for-experience-owners"
},
{
  label: "MotoSenseIQ",
  href: "/for-drivers"
},
{
  label: "Pricing",
  href: "/pricing"
},
{
  label: "How It Works",
  href: "/how-it-works"
}];


const COMPANY_LINKS = [
{
  label: "About Us",
  href: "/about"
},
{
  label: "Contact",
  href: "/contact"
},
{
  label: "Blog",
  href: "/blog"
},
{
  label: "FAQ",
  href: "/faq"
},
{
  label: "Press",
  href: "/press"
}];


const LEGAL_LINKS = [
{
  label: "Privacy Policy",
  href: "/privacy-policy"
},
{
  label: "Terms of Service",
  href: "/terms"
},
{
  label: "Cookie Policy",
  href: "/cookie-policy"
}];

export const Footer = () => {
  return (
    <footer className="bg-secondary border-t border-border">
      {/* Newsletter Section */}
      <div className="border-b border-border">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-10">
          <div className="max-w-xl mx-auto md:mx-0">
            <NewsletterSignup />
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-10 md:gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-3 lg:col-span-2">
            <div className="mb-4">
              <img src={motorevealLogo} alt="MotoReveal" className="h-5" />
            </div>
            <p className="text-muted-foreground text-sm mb-6 max-w-xs">
              Connecting car enthusiasts worldwide through events, experiences, and community. Fuel your passion for
              motorsports.
            </p>
            <div className="flex items-center gap-3">
              {SOCIAL_LINKS.map((social) =>
              <a
                key={social.label}
                href={social.href}
                aria-label={social.label}
                className="w-10 h-10 rounded-full bg-background border border-border flex items-center justify-center hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors">

                  <social.icon className="w-4 h-4" />​
                </a>
              )}
            </div>
          </div>

          {/* Explore Links */}
          <div>
            <h4 className="text-sm font-semibold mb-4">Explore</h4>
            <ul className="space-y-3">
              {EXPLORE_LINKS.map((link) =>
              <li key={link.label}>
                  <Link
                  to={link.href}
                  className="text-muted-foreground hover:text-foreground transition-colors text-sm">

                    {link.label}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* For Listers Links */}
          <div>
            <h4 className="text-sm font-semibold mb-4">For Listers</h4>
            <ul className="space-y-3">
              {FOR_LISTERS_LINKS.map((link) =>
              <li key={link.label}>
                  <Link
                  to={link.href}
                  className="text-muted-foreground hover:text-foreground transition-colors text-sm">

                    {link.label}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-sm font-semibold mb-4">Company</h4>
            <ul className="space-y-3">
              {COMPANY_LINKS.map((link) =>
              <li key={link.label}>
                  <Link
                  to={link.href}
                  className="text-muted-foreground hover:text-foreground transition-colors text-sm">

                    {link.label}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="text-sm font-semibold mb-4">Legal</h4>
            <ul className="space-y-3">
              {LEGAL_LINKS.map((link) =>
              <li key={link.label}>
                  <Link
                  to={link.href}
                  className="text-muted-foreground hover:text-foreground transition-colors text-sm">

                    {link.label}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                
                <a
                  className="text-muted-foreground hover:text-foreground transition-colors text-sm"
                  href="mailto:hello@motoreveal.com">

                  hello@motoreveal.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                
                
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-muted-foreground text-sm">
              © {new Date().getFullYear()} MotoReveal. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <button
                onClick={showCookieBanner}
                className="flex items-center gap-1.5 text-muted-foreground hover:text-foreground transition-colors text-sm">

                <Settings className="w-3.5 h-3.5" />
                Cookie Preferences
              </button>
              
            </div>
          </div>
        </div>
      </div>
    </footer>);

};